import Vue from 'vue';
import Vuex from 'vuex';
import types from '@/store/types';
import api from '@/utils/api';
import utils from '@/utils';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMaster: String(utils.getItem('isMaster')) == "true",
    navs__primary: null,
    navs__secondary: null,
    enableFloating: false,
    enableLogin: false,
    disableLayout: false,
    enableSearch: false,
    isLogin: utils.hasItem('token'),
    userInfo: JSON.parse(utils.getItem("userInfo")),
    userFullInfo: null,
    cartInfo: null,
    favPids: [],
    utm:JSON.parse(sessionStorage.getItem("utm")),
    notice: null,
    siteConfig:JSON.parse(utils.getItem("siteConfig")),
    enableMiniCar: false,
    theme: null,
    ebaDialog: {
      dialog: false,
      url: ''
    },
    isToast:false,
    showVisitor: false,
	sustainabilityPath:{
		type:'1',
	}
  },
  getters: {
    navList(state) {
      return state.isMaster ? state.navs__primary : state.navs__secondary;
    },
    utm(state) {
      return state.utm;
    }
  },
  mutations: {
    // 切换导航类型
    toggleNavType(state, isMaster) {
      state.isMaster = !!isMaster;
      utils.setItem('isMaster', state.isMaster);
    },
    // 保存导航菜单数据
    saveNavList(state, payload) {
      let { primary, secondary } = payload;
      primary && this.commit('savePrimaryNavs', primary);
      secondary && this.commit('saveSecondaryNavs', secondary);
    },
    // 保存主导航菜单数据
    savePrimaryNavs(state, payload) {
      if (payload && Array.isArray(payload)) {
        state.navs__primary = payload;
      } else {
        console.warn('[warn] 主导航数据缺失或格式错误');
      }
    },
    // 保存副导航菜单数据
    saveSecondaryNavs(state, payload) {
      if (payload && Array.isArray(payload)) {
        state.navs__secondary = payload;
      } else {
        console.warn('[warn] 副导航数据缺失或格式错误');
      }
    },
    // 切换导航浮动状态
    toggleNavFloating(state, enableFloating) {
      state.enableFloating = !!enableFloating;
    },
    // 切换登录框显示状态
    toggleLogin(state, payload) {
      state.enableLogin = payload;
    },
    // 切换公用 Header & Footer 显示状态
    disableLayout(state, payload) {
      state.disableLayout = payload;
    },
    saveTmepUser(state, payload) {
      state.tempUser = payload;
    },
    saveUserFullInfo(state, payload) {
      state.userFullInfo = payload;
    },
    saveUTMInfo(state, payload) {
      sessionStorage.setItem("utm", JSON.stringify(payload));
      state.utm = payload;
    },
    clearUTMInfo(state) {
      utils.removeItem("utm");
      state.utm = {};
    },
    toggleSearch(state, payload) {
      state.enableSearch = !!payload;
      if (state.enableSearch) {
        document.documentElement.classList.add("js-no-scroll");
      } else {
        document.documentElement.classList.remove("js-no-scroll");
      }
    },
    // 登录后保存 token & refresh_token
    [types.USER_LOGIN](state, payload) {
      payload.token && utils.setItem('token', payload.token);
      payload.refresh_token && utils.setItem('refresh_token', payload.refresh_token);
      if (payload?.data?.user_id) {
        utils.setItem('userInfo', payload.data);
        state.userInfo = payload.data;
      }
      state.isLogin = true;
    },
    // 退出后移除 token & refresh_token & userInfo
    [types.LOGOUT](state, payload) {
      utils.removeItem('token');
      utils.removeItem('refresh_token');
      utils.removeItem('userInfo');
      state.isLogin = false;
      state.userInfo = null;
      state.userFullInfo = null;
      state.favPids = [];
      typeof payload == "function" && payload();
    },
    // 保存用户信息
    [types.GET_PROFILE](state, payload) {
      utils.setItem("userInfo", JSON.stringify(payload));
      state.userInfo = payload;
    },
    // 保存购物车信息
    [types.CART_GET](state, payload) {
      state.cartInfo = payload;
    },
    // 保存用户收藏的产品ID数组
    [types.FAV_PIDS_LIST](state, payload) {
      Array.isArray(payload) && (state.favPids = payload);
    },
    // 保存公告通知数据
    [types.NOTICE](state, payload) {
      if (payload && (payload.pc || payload.h5)) {
        state.notice = payload;
      } else {
        console.warn('公告通知数据格式不正确: ', payload);
      }
    },
    // 切换登录框显示状态
    siteConfig(state, payload) {
      state.siteConfig = payload;
    },
    // 切换minicar
    toggleMiniCar(state, payload) {
      state.enableMiniCar = payload;
    },
    siteTheme(state, payload){
      state.theme = payload
    },
    setEbaDialog(state, payload){
      state.ebaDialog = payload
    },
    setToast(state, payload){
      state.isToast = payload
    },
    toggleShowVisitor(state, payload) {
      state.showVisitor = payload;
    },
	/** 跳转ref */
	toSustainability(state,i){
		state.sustainabilityPath={
			type:i
		}
		console.log(state)
	}
  },
  actions: {
    [types.LOGOUT]({ state, commit, dispatch }, payload) {
      if (!state.isLogin) return;
      api[types.LOGOUT]().then(() => {
        commit(types.LOGOUT, payload);
        dispatch(types.CART_GET);
      }).catch(err => {
        console.warn(err);
      });
    },
    // eslint-disable-next-line no-unused-vars 
    [types.GET_PROFILE]({state, rootState, getters, rootGetters, dispatch, commit}, payload) {
      api[types.GET_ACCOUNT_INFO]({
        key: 'userInfo'
      }).then(res => {
        if (res.code == 1) {
          let { base_info, customer_level, total_points, shipping_address, benefit_info, coupon_list, order_list, active_info  } = res.data;
          // 用户基础数据
          commit(types.GET_PROFILE, base_info);
          // 用户所有数据
          commit('saveUserFullInfo', {
            base_info,
            customer_level,
            total_points,
            shipping_address,
            benefit_info,
            coupon_list,
            order_list,
            active_info,
            original_level: res.data.original_level || 0
          });
        } else if (res.code != 2) {
          console.warn("用户数据同步失败");
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    [types.CART_GET]({ state, commit }, payload) {
      let newArgs = null;
      let localCart = utils.getCartInfo();
      // 将本地购物车数据合并查询
      if (localCart?.goods_list?.goods?.length) {
        newArgs = {};
        // let ret = [];
        // localCart.goods_list.goods.forEach(item => {
        //   if (item?.main?.length) {
        //     item.main.forEach(subItem => {
        //       ret.push(`${subItem.id},${subItem.qty}`); // unique_id
        //     })
        //   }
        // });
        let ret = localCart.goods_list.goods.map(item => `${item.id},${item.quantity},${item.selected?1:0}`);
        newArgs.ids = ret.join("|");
        // 
        let free = localCart.goods_list.free_try.map(item => item.id);
        free.length && (newArgs.free_ids = free.join(","));
        // 登录状态则清空本地购物车信息
        state.isLogin && utils.clearCart(true);
      }
      // 
      if ((!newArgs || !newArgs.ids) && !state.isLogin) {
        commit(types.CART_GET, null);
        return console.info("[info] 无本地预购信息或用户未登录"), false;
      }
      // 
      api[types.CART_GET](newArgs).then(res => {
        if (res.code == 1) {
          if (res?.data?.goods_list?.goods) {
            commit(types.CART_GET, res.data);
          } else {
            commit(types.CART_GET, {
              goods_list: {
                goods: [],
                free_try: []
              },
              total: {
                total_product_price: 0,
                total_discount: 0,
                total_used_points: 0,
                total_ship_fee: 0,
                total_wrap_fee: 0,
                total_amount: 0
              }
            });
          }
          utils.isFunction(payload) && payload();
        } else {
          console.warn(res);
          this._vm.$toast("购物车数据同步失败");
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // eslint-disable-next-line no-unused-vars 
    [types.FAV_PIDS_LIST]({state, commit}, payload) {
      if (!state.isLogin) return false;
      api[types.FAV_PIDS_LIST]().then(res => {
        if (res.code == 1) {
          res.data?.pids && commit(types.FAV_PIDS_LIST, res.data.pids);
        } else if (res.code != 2) {
          console.warn(res);
          this._vm.$toast(res.message || "用户收藏数据同步失败");
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    // 加载公告通知数据
    [types.NOTICE]({ commit }) {
      api[types.NOTICE]().then(res => {
        if (res.code == 1) {
          commit(types.NOTICE, res.data);
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  }
})